import request from '@/utils/request'

let ReportApi = {

  /*举报处理列表*/
  list(data) {
    return request._post('/shop/plus.report.Index/index', data);
},
/*添加举报处理*/
add(data) {
    return request._post('/shop/plus.report.Index/add', data);
},
/*修改举报处理*/
edit(data) {
    return request._post('/shop/plus.report.Index/edit', data);
},
/*删除举报处理*/
del(data) {
    return request._post('/shop/plus.report.Index/del', data);
},
/*举报处理详情*/
detail(data) {
  return request._post('/shop/plus.report.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.report.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.report.Setting/getSetting', data, errorback);
    },
    editPart(data) {
        return request._post('/shop/plus.report.Index/editPart', data);
    },
}
export default ReportApi;



// WEBPACK FOOTER //
// ./src/api/report.js